import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { history } from "../../../_helpers";
import suscripcionService from "../../../_services/cart/suscripcion.service";
import tiendaService from "../../../_services/cart/tienda.service";

/**
 * A donde vuelve el vendedor despues de autorizar el debito en Mercado Pago (`app.mp.platform.backUrl`).
 * Portada de tienda-admin (`pages/subscription-success`, 13b5a5b), mismo texto.
 */
export const SuscripcionOk = () => {
    const [configurarTienda, setConfigurarTienda] = useState(false);

    useEffect(() => {
        // El estado cambia cuando llega el aviso de MP: que el menu no muestre el viejo.
        suscripcionService.olvidar();
        // Con el plan Tienda propia, lo siguiente es elegir la direccion: se ofrece aca mismo.
        tiendaService.config()
            .then((c) => setConfigurarTienda(c.habilitada && !c.subdominio))
            .catch(() => {});
    }, []);

    return (
        <div className="suscripcion-checkout">
            <div className="suscripcion-checkout__card">
                <FontAwesomeIcon icon="fa-solid fa-circle-check" size="4x" className="suscripcion-checkout__ok" />
                <h2>¡Suscripción registrada!</h2>
                <p className="suscripcion-checkout__sub">
                    Tu suscripción fue procesada. En breve la activamos y vas a poder seguir usando todo deautopartes.
                </p>
                {configurarTienda && (
                    <p className="suscripcion-checkout__sub">
                        Tu plan incluye tienda propia: elegí la dirección, subí tu logo y quedó lista.
                    </p>
                )}
                {configurarTienda ? (
                    <button type="button" className="button suscripcion-checkout__boton" data-type="accent" onClick={() => history.push("/vendedor/tienda")}>
                        Configurar mi tienda
                    </button>
                ) : (
                    <button type="button" className="button suscripcion-checkout__boton" data-type="accent" onClick={() => history.push("/vendedor/plan")}>
                        Ver mi plan
                    </button>
                )}
            </div>
        </div>
    );
};
